import React, { useEffect, useState } from 'react'
import ConfirmationModal, { Props as ModalProps } from '.'
import { useBlocker } from 'hooks/use-blocker'

type Props = Partial<ModalProps> & {
  showConfirmation: boolean
}

const RouteConfirmationModal: React.FC<Props> = ({
  cancel,
  submit,
  showConfirmation,
  variant = 'discard',
  ...props
}) => {
  const [flags, setFlags] = useState<{ isVisible?: boolean; nextPath?: string; tx: any }>()

  // Before unload on browser refresh
  useEffect(() => {
    const beforeUnload = (e: BeforeUnloadEvent) => {
      if (showConfirmation) {
        e.preventDefault()
        e.returnValue = ''
      }
    }
    window.addEventListener('beforeunload', beforeUnload)
    return () => window.removeEventListener('beforeunload', beforeUnload)
  }, [showConfirmation])

  // Block navigation using React Router v6 blocker
  useBlocker((tx) => {
    setFlags({ isVisible: true, nextPath: tx.location.pathname, tx })
  }, showConfirmation)

  const dismissModal = () => {
    setFlags(undefined)
  }

  const handleCancel = () => {
    dismissModal()
    cancel?.()
  }

  const handleSubmit = () => {
    dismissModal()
    submit?.()
    if (flags?.nextPath) {
      // flags?.tx?.retry?.()
      // navigate({ pathname: flags.nextPath }, { replace: true })
      window.location.pathname = flags.nextPath
    }
  }

  if (flags?.isVisible) {
    return <ConfirmationModal {...props} variant={variant} cancel={handleCancel} submit={handleSubmit} />
  }

  return null
}

export default RouteConfirmationModal
